import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);

export const buildWaLink = (contacts, msg) => {
  const num = (contacts?.whatsapp || "351912345678").replace(/\D/g, "");
  const text = msg || contacts?.whatsapp_message || "Olá 3Duo!";
  return `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(() => {
    return api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({ contacts: {}, seo: {} }));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <Ctx.Provider value={{ settings, refresh }}>{children}</Ctx.Provider>;
};

export const useSettings = () => useContext(Ctx);
